// extracted by mini-css-extract-plugin
export default {"wrapper":"Return_wrapper__nOz0f","info":"Return_info__+KHSr","action":"Return_action__PP+95"};